import React, { FC } from 'react';

import Chip from '@mui/material/Chip';

import { WORK_TYPE_LABELS } from '../utils/projectsUtils';

const WORK_TYPE_COLORS: Record<string, { backgroundColor: string; color: string }> = {
  'PROJ-SCOPE': { backgroundColor: '#fffde7', color: '#827717' },
  'PROJ-INSTA': { backgroundColor: '#e1f5fe', color: '#01579b' },
  'PROJ-START': { backgroundColor: '#f3e5f5', color: '#6a1b9a' },
};

interface WorkTypeChipProps {
  workType: string;
}

const WorkTypeChip: FC<WorkTypeChipProps> = ({ workType }) => {
  const colors = WORK_TYPE_COLORS[workType] || { backgroundColor: '#eceff1', color: '#455a64' };

  return (
    <Chip
      label={WORK_TYPE_LABELS[workType] || workType}
      size="small"
      variant="outlined"
      sx={{ ...colors, fontWeight: 600, borderColor: colors.color }}
    />
  );
};

export default WorkTypeChip;
